'use client'

import { SectionHeader } from '@/components/section-header'
import { useState } from 'react'

export const FAQ = () => {
  const [activeTab, setActiveTab] = useState<'registration' | 'purchase' | 'delivery'>('registration')
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const tabs = [
    { id: 'registration' as const, label: '無料アカウント登録について' },
    { id: 'purchase' as const, label: 'ご購入について' },
    { id: 'delivery' as const, label: 'お届けについて' },
  ]

  const faqData = {
    registration: [
      {
        id: 'registration-1',
        question: '会員登録が必要ですか？',
        answer:
          'eカタログをご利用いただくには新規会員登録（無料）が必須となります。\n新規会員登録は「無料アカウント登録」ボタンからお手続きをお願いします。',
      },
      {
        id: 'registration-2',
        question: '新規会員登録はどうやってできますか？',
        answer: '「無料アカウント登録」ボタンからお手続きをお願いします。',
      },
    ],
    purchase: [
      {
        id: 'purchase-1',
        question: 'オリジナルeカタログはどのようなものですか？',
        answer: 'わかりやすい動画をご用意しておりますので、ぜひご覧ください。',
      },
      {
        id: 'purchase-2',
        question: '購入代金の内訳を教えてください',
        answer: '当社のeカタログは、eカタログ代金のみをいただくサービスです。\nシステム利用料や送料はかかりません。',
      },
      {
        id: 'purchase-3',
        question: 'ギフトは一つからでも購入できますか？',
        answer: 'はい。お一つからもご購入が可能です。',
      },
      {
        id: 'purchase-4',
        question: 'eカタログギフトに使用期限はありますか？',
        answer:
          '有効期限は、eカタログ発行後６ヶ月です。\n有効期限を過ぎますと、ギフトコードが無効となり、贈り先様が商品を選択できなくなります。',
      },
      {
        id: 'purchase-5',
        question: 'eカタログ発行後に、内容の変更・追加注文はできますか？',
        answer:
          'ご注文いただいたeカタログには、各eカタログに個別のギフトコードが発行されます。そのため、一度当社からギフトコードが発行された後の変更はお受けできません。',
      },
      {
        id: 'purchase-6',
        question: 'キャンセルしたい',
        answer:
          '商品の特性上、お客様のご都合によるご注文のキャンセルは、ご注文商品の一部・全部を問わずお受けできません。\nまた、既にお申し込みいただいた情報を訂正したい場合には、{{link:contact}}よりご連絡ください。',
      },
      {
        id: 'purchase-7',
        question: '領収書を発行してほしい',
        answer: 'eカタログご購入・ご入金後、{{link:contact}}より、領収書ご希望の旨をご連絡ください。',
      },
      {
        id: 'purchase-8',
        question: '支払方法を教えてほしい',
        answer: 'こちらをご確認ください　{{link:payment}}',
      },
      {
        id: 'purchase-9',
        question: '退会したい',
        answer: '{{link:contact}}より、退会の旨をご連絡ください。',
      },
    ],
    delivery: [
      {
        id: 'delivery-1',
        question: '配送料はかかりますか？',
        answer: '全国一律送料無料でお届けいたします。一部離島・遠隔地の場合は別途ご相談ください。',
      },
      {
        id: 'delivery-2',
        question: '配送にはどのくらいかかりますか？',
        answer: 'ご注文確定後、通常3〜5営業日でお届けいたします。お急ぎの場合は、お問い合わせください。',
      },
      {
        id: 'delivery-3',
        question: '配送先を複数指定できますか？',
        answer: 'はい、可能です。CSVファイルで一括登録いただくことも可能ですので、大量配送にも対応しております。',
      },
      {
        id: 'delivery-4',
        question: '配送状況は確認できますか？',
        answer:
          'マイページから配送状況をリアルタイムでご確認いただけます。発送時には追跡番号をメールでお知らせいたします。',
      },
    ],
  }

  const currentFaqs = faqData[activeTab]

  // リンクを含むテキストを処理する関数
  const parseAnswerWithLinks = (answer: string) => {
    const linkMap: Record<string, { text: string; url: string; isInternal?: boolean }> = {
      contact: { text: 'お問い合わせフォーム', url: '/#contact', isInternal: true },
      payment: { text: 'お支払い方法について', url: 'https://catalog-giftmall.notion.site/payment' },
    }

    const parts = answer.split(/({{link:\w+}})/)
    return parts.map(part => {
      const match = part.match(/{{link:(\w+)}}/)
      if (match) {
        const linkKey = match[1]
        const linkInfo = linkMap[linkKey]
        if (linkInfo) {
          if (linkInfo.isInternal) {
            return (
              <a
                key={`link-${linkKey}-${part}`}
                href={linkInfo.url}
                style={{
                  color: '#009CD2',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                }}
                onClick={e => {
                  e.preventDefault()
                  const contactSection = document.getElementById('contact')
                  if (contactSection) {
                    window.history.pushState(null, '', '/?form=contact')
                    contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
                  }
                }}
              >
                {linkInfo.text}
              </a>
            )
          }
          return (
            <a
              key={`link-${linkKey}-${part}`}
              href={linkInfo.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#009CD2',
                textDecoration: 'underline',
              }}
            >
              {linkInfo.text}
            </a>
          )
        }
      }
      return <span key={`text-${part.slice(0, 10)}`}>{part}</span>
    })
  }

  return (
    <section className="w-full py-8 lg:py-8 px-4 lg:px-[240px]" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-[1440px] mx-auto flex flex-col gap-4">
        <SectionHeader title="よくある質問" />

        {/* タブとコンテンツ */}
        <div className="flex flex-col gap-8">
          {/* タブ */}
          <div className="flex overflow-x-auto">
            {tabs.map(tab => (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                className="flex-1 py-2 lg:py-3 border-b text-center transition-colors whitespace-nowrap text-xs lg:text-base"
                style={{
                  borderBottomWidth: activeTab === tab.id ? '2px' : '1px',
                  borderBottomColor: '#009CD2',
                  fontWeight: 700,
                  letterSpacing: '0.48px',
                  lineHeight: '1.6',
                  color: activeTab === tab.id ? '#009CD2' : 'rgba(36, 36, 36, 0.6)',
                  cursor: 'pointer',
                  minWidth: 'fit-content',
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* FAQアイテム */}
          <div className="flex flex-col gap-8">
            {currentFaqs.map((faq, index) => {
              const isOpen = openIndex === index
              return (
                <div
                  key={faq.id}
                  className="border rounded-lg overflow-hidden"
                  style={{
                    borderColor: '#EBEBEB',
                  }}
                >
                  {/* 質問部分 */}
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="flex items-center justify-between px-4 lg:px-8 py-3 lg:py-4 w-full text-left transition-colors hover:bg-gray-50"
                    style={{
                      cursor: 'pointer',
                    }}
                  >
                    <span
                      className="text-sm lg:text-base"
                      style={{
                        flex: 1,
                        fontWeight: 500,
                        letterSpacing: '0.56px',
                        lineHeight: '1.6',
                        color: '#363636',
                      }}
                    >
                      {faq.question}
                    </span>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{
                        transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)',
                        transition: 'transform 0.3s ease',
                      }}
                      aria-hidden="true"
                    >
                      <title>{isOpen ? '閉じる' : '開く'}</title>
                      <path d="M12 5V19" stroke="#363636" strokeWidth="2" strokeLinecap="round" />
                      <path d="M5 12H19" stroke="#363636" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </button>

                  {/* 回答部分（アコーディオン） */}
                  <div
                    style={{
                      maxHeight: isOpen ? '500px' : '0',
                      opacity: isOpen ? 1 : 0,
                      overflow: 'hidden',
                      transition: 'max-height 0.4s ease, opacity 0.3s ease',
                    }}
                  >
                    <div
                      className="px-4 lg:px-8 py-3 lg:py-4 border-t"
                      style={{
                        borderTopColor: '#EBEBEB',
                        backgroundColor: '#FAFAFA',
                      }}
                    >
                      <div
                        className="text-xs lg:text-sm"
                        style={{
                          fontWeight: 400,
                          letterSpacing: '0.48px',
                          lineHeight: '1.6',
                          color: '#363636',
                          whiteSpace: 'pre-wrap',
                        }}
                      >
                        {parseAnswerWithLinks(faq.answer)}
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}
